<template>
  <div v-if="isShow.isPTShow" class="pg2">
    <div class="pos-wp">
      <div class="pos" :class="`pos${result}`"></div>
      <div class="pos-desc">
        <h3 class="pos-title">春天飞花令榜单</h3>
        <p class="pos-name">{{ name }}</p>
        <p class="pos-para">恭喜您！ 荣获“2020年春之美·春之韵·春之情”飞花令<span class="pos-para__s">{{ userTitle }}</span>！感受春天，你最厉害！</p>
        <p class="pos-footer">简豆教育诗词研究社 2020年{{new Date().getMonth() + 1}}月{{new Date().getDate()}}日</p>
        <div class="pos-logo"></div>
      </div>
    </div>
    <p class="notice shine">&lt;长按图片保存海报&gt;</p>
    <div class="btn-group">
      <div class="btn" @click="rePlay">再测一次</div>
      <div class="btn" @click="toggleMask(true)">立即分享</div>
    </div>
    <div class="copyright">创意执行：简豆科技</div>
    <img :src="poster" alt="" class="poster">
    <div class="mask" v-show="isMask" @click="toggleMask(false)">
      <div class="mask-share"></div>
      <p>点击右上角立即分享</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageTwo',
  props: {
    isShow: Object,
    poster: String,
    result: Number,
    name: String
  },
  data() {
    return {
      score: 1,
      isMask: false,
    }
  },
  computed: {
    userTitle() {
      const score = +this.result;
      switch (score) {
        case 1:
          return '状元';
        case 2:
          return '榜眼';
        case 3:
          return '探花';
        case 4:
          return '进士';
        default:
          return '';
      }
    }
  },
  methods: {
    toggleMask(para) {
      this.isMask = para;
    },
    rePlay() {
      window.location.href = 'https://www.jiandoukeji.com/h5/h5-effects/poem-course/index.html'
    }
  }
}
</script>

<style lang="less" scoped>
.bg(@url) {
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url(@url);
}
.pg2 {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background-color: lightgoldenrodyellow;
  .bg('./img/ld-bg.jpg');
}
.pos-wp {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.pos {
  width: 44.375/2rem /* 710/16 */;
  height: 65.875/2rem /* 1054/16 */;
}
.pos1 {
  .bg('./img/display-pos1.png');
}
.pos2 {
  .bg('./img/display-pos2.png');
}
.pos3 {
  .bg('./img/display-pos3.png');
}
.pos4 {
  .bg('./img/display-pos4.png');
}
.pos-desc {
  position: absolute;
  bottom: -2rem;
  box-sizing: border-box;
  padding: 4.125/2rem /* 66/16 */ 2rem /* 50/16 */ 0 1.8rem /* 85/16 */;
  width: 42.5625/2rem /* 681/16 */;
  height: 21.875/2rem /* 350/16 */;
  .bg('./img/description.png');
  font-family: font-kt;
  color: #666666;
}
.pos-title {
  margin-bottom: .2rem;
  text-align: center;
  font-family: font-kt;
  color: #9c6515;
}
.pos-name {
  font-size: .875rem /* 14/16 */;
  line-height: 1.2;
  color: #e74445;
  text-decoration: underline;
}
.pos-para {
  margin: .4rem 0 .8rem;
  font-size: .875rem /* 14/16 */;
  line-height: 1.4;
}
.pos-para__s {
  font-size: .875rem /* 14/16 */;
  color: #e74445;
  text-decoration: underline;
}
.pos-footer {
  font-size: .75rem /* 12/16 */;
  line-height: 1.4;
}
.pos-logo {
  position: absolute;
  bottom: 1.8rem;
  right: 3rem;
  width: 4.5/2rem /* 72/16 */;
  height: 2.9375/2rem /* 47/16 */;
  .bg('./img/logo.png');
}
.notice {
  font-family: font-kt;
  color: #666666;
  margin-top: 2rem;
  text-shadow: 0 0 10px rgba(0, 0, 0, .2);
}
.btn-group {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: .6rem;
  z-index: 3;
}
.btn {
  width: 20.3125/2rem /* 325/16 */;
  height: 6.5/2rem /* 104/16 */;
  .bg('./img/btn-box.png');
  font-family: font-kt;
  text-align: center;
  line-height: 6.5/2rem /* 104/16 */;
  color: #9c6515;
  letter-spacing: 4px;
  transition: all .3s;
  &:active {
    opacity: .8;
    transform: scale(.94);
  }
  &:first-child {
    margin-right: 1rem;
  }
}
.copyright {
  position: absolute;
  bottom: 2vh;
  left: 50%;
  transform: translateX(-50%);
  font-family: font-kt;
  font-size: .75rem /* 12/16 */;
  color: white;
  text-shadow: 0 0 10px #eee;
}
.poster {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 82%;
  opacity: 0;
}
.mask {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, .8);
  z-index: 12;
  p {
    position: absolute;
    left: 50%;
    top: 14rem;
    font-family: font-kt;
    color: white;
    text-shadow: 0 0 10px #eee;
    transform: translateX(-50%);
  }
}
.mask-share {
  position: absolute;
  right: 1rem;
  top: 1rem;
  width: 18.1875/2rem /* 291/16 */;
  height: 23.5625/2rem /* 377/16 */;
  .bg('./img/mask-flower.png');
}
.shine {
  animation: shine 1.2s ease-in-out infinite;
}
@keyframes shine {
  0%, 100% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
}
@media screen and (max-height: 700px) {
  .pos-wp {
    transform: scale(.8);
  }
  .notice {
    margin-top: -1.5rem;
  }
  .btn-group {
    margin-bottom: 2rem;
    margin-top: 0.5;
  }
}
@media screen and (min-width: 376px) and (max-width: 414px) and (max-height: 770px) {
  .pos-wp {
    transform: scale(.8);
  }
  .notice {
    margin-top: -1.5rem;
  }
  .btn-group {
    margin-bottom: 2rem;
    margin-top: 0.5;
  }
}
</style>
